import {Cache} from "./Cache";

class DisOrderDep extends Cache {
    constructor() {
        super(true);
        this.key += '_doc_order';
    }
}

class DisOrderDoc extends Cache {
    constructor() {
        super(true);
        this.key += '_dep_order';
    }
}


class DisOrderType extends Cache {
    constructor() {
        super(true);
        this.key += '_type_order';
    }
}

export const disDepCache = new DisOrderDep();

export const disDocCache = new DisOrderDoc();

export const disTypeCache = new DisOrderType();
